/*
 * SPDX-License-Identifier: Proprietary
 *
 * Copyright 2021 Jeremy A Gray <gray@flyquackswim.com>.
 */

// React Bootstrap.
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Container from 'react-bootstrap/Container';

import React from 'react';

import './Header.css';

const Header = (props) => {
  return (
    <header className="AppHeader">
      <Navbar
        expand="lg"
      >
        <Container>
          <Navbar.Brand href="/" className="d-none d-md-block">
            Tysk:  Get Stuff Done
          </Navbar.Brand>
          <Navbar.Brand href="/" className="d-small d-md-none">
            Tysk
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav"/>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav
              className="ms-auto"
            >
              <NavDropdown
                title="Account"
                id="tysk-navbar-account-dropdown"
                align="end"
              >
                <NavDropdown.Item
                  href="/"
                  className="text-end"
                >
                  Register
                </NavDropdown.Item>
                <NavDropdown.Item
                  href="/"
                  className="text-end"
                >
                  Login
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
}

export default Header;
